import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { EducationExpensesStyled } from '../../../asset/styled/deductions/EducationExpensesStyled';
import titleImg from '../../../asset/img/education_title_img.svg';

import InfoBanner from '../../../components/Banner';
import TotalSection from '../../../components/TotalSection';
import SubTitleSection from '../../../components/SubTitleSection';
import EducationItemSection from './EducationItemSection';
import { useSelector } from 'react-redux';
import EducationDetail from './detail';

const EducationExpenses = () => {
  const { t } = useTranslation('deductions/education');
  const { total } = useSelector(state => state.education);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };
  return (
    <EducationExpensesStyled>
      <InfoBanner title={t('bannerSection.title')} description={t('bannerSection.description')} />
      <SubTitleSection title={t('title')} img={titleImg} />
      <EducationItemSection onOpen={handleOpen} />
      {/* 합계 */}
      <TotalSection total={total} />

      <EducationDetail isOpen={isOpen} onClose={handleClose} />
    </EducationExpensesStyled>
  );
};

export default EducationExpenses;
